import { Status} from "./models/status.model";
import { Injectable } from "@angular/core";

@Injectable()
export class PinCodeStatusService{
  constructor(){
    
  }
  getListPinCodeStatus():Status[]{
    let statusList:Status[]=[];    
    statusList.push( new Status(0, 'Khóa'));
    statusList.push( new Status(1, 'Mới'));
    statusList.push( new Status(2, 'Đã bán'));
    return statusList;
  }
}